var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_234_4739",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H56V42H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_234_4739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93334 37.3333C2.93334 23.4894 14.1561 12.2666 28 12.2666C41.8439 12.2666 53.0667 23.4894 53.0667 37.3333C53.0667 43.2739 51.0009 48.7305 47.5479 53.0261H8.45212C4.99914 48.7305 2.93334 43.2739 2.93334 37.3333Z",
    stroke: "white",
    strokeWidth: 1.2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 43.7333C25.7541 43.7333 23.9333 41.9126 23.9333 39.6666C23.9333 38.3018 24.6052 37.0938 25.6388 36.3552L40.1962 27.4705L31.314 42.0242C30.5757 43.0599 29.3665 43.7333 28 43.7333Z",
    stroke: "white",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a625efd9d96621590905918266b39028.svg";
export { ForwardRef as ReactComponent };